import { createContext, SetStateAction, Dispatch } from "react";
import { GenerateAPQuotationServiceRequest } from "../../../../../../../../shared/interfaces";

interface WizardDataFormContextProps {

    /** Variable to save all info about Consortium Integral quotation request, for generate quotation or requotations */
    quotationForm:             GenerateAPQuotationServiceRequest | undefined;
    setQuotationForm:          Dispatch<SetStateAction<GenerateAPQuotationServiceRequest | undefined>>

    handleTabErrors:           (errorFields: any[], tabPrefix: string[], tabName: string) => void;
}

export const WizardDataFormContext = createContext({} as WizardDataFormContextProps);